import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const Designation = () => {
  return(
    <SettingsMetaData propertyName={"AgentDesignation"} viewPropertyName={"Agent Designation"} />
  )
};

export default Designation;
